var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$auth.check(['superuser']) && _vm.$route.name !== 'login')?_c('div',[_c('router-view')],1):(_vm.$route.name === 'login')?_c('div',[_c('router-view')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }